// extracted by mini-css-extract-plugin
export default {"cast":"Cast_cast__2nFRb","appear":"Cast_appear__Szwm3","cast_img":"Cast_cast_img__L+x2x","cast_info":"Cast_cast_info__IptgB","cast_name":"Cast_cast_name__4e5NS"};